import { Model, Factory } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import {
  randNumber,
  randCompanyName,
  randPastDate,
  randRecentDate,
  randFutureDate,
  rand,
  randAlphaNumeric,
  randBoolean,
} from '@ngneat/falso'

import type { SchemaAttributes } from '../types.js'
import type { MockServer } from './server.js'

export type OrganizationData = SchemaAttributes<'Organization'>

export const model = Model as ModelDefinition<OrganizationData>

export const factory = Factory.extend<OrganizationData>({
  provet_id() {
    return randNumber({ min: 1, max: 999 })
  },
  name() {
    return randCompanyName()
  },
  created() {
    return randPastDate().toISOString()
  },
  modified() {
    return randRecentDate().toISOString()
  },
  activated() {
    return randPastDate().toISOString()
  },
  deactivated() {
    return null
  },
  destroyed() {
    return null
  },
  is_active() {
    return true
  },
  is_blocked() {
    return false
  },
  campaign_code() {
    return rand([null, randAlphaNumeric({ length: 8 }).join('')])
  },
  billing() {
    return rand([1, 2]) // 1 = Old, 2 = Stripe
  },
  trial_endtime() {
    return rand([null, randFutureDate().toISOString()])
  },
  confirmed() {
    return true
  },
  confirmed_at() {
    return randPastDate().toISOString()
  },
  confirmed_user_id() {
    return rand([null, randNumber({ min: 1, max: 100 })])
  },
  can_send_email() {
    return true
  },
  can_send_sms() {
    return randBoolean()
  },
  sms_billing() {
    return rand([1, 2]) // 1 = Prepaid, 2 = Postpaid
  },
  is_paying_customer() {
    return randBoolean()
  },
})

export function routes(server: MockServer) {
  server.get('/organizations/current', (schema) => schema.first('organization'))
}

export function seeds(server: MockServer) {
  server.create('organization', {
    id: '1',
    provet_id: 33,
    name: 'Provet Demo Organization',
    is_active: true,
    is_blocked: false,
    confirmed: true,
    can_send_email: true,
    can_send_sms: true,
    billing: 2, // Stripe
    sms_billing: 2, // Postpaid
    is_paying_customer: true,
  })
}
